import { EnumTipoElemLog, EnumZonaBalance, EnumSubTipoElemLog } from '../enums';

export interface ElementoLogisticoPunto {
  id: number;
  descripcion?: string;
  tipoElementoLogistico: EnumTipoElemLog;
  subtipoElementoLogistico: EnumSubTipoElemLog;
  subtiposAsociados: Array<EnumSubTipoElemLog>;
  codElementoLogistico?: string;
  codAcer?: string;
  zonaBalance?: EnumZonaBalance;
}

export type LogisticElementSubTypePoint = 'PTO_PCPR' | 'PTO_PCDB' | 'PTO_PCCC' | 'PTO_PCAS' | 'PTO_PCI' | 'PTO_PCY' | 'PTO_PCTD' | 'PTO_PCDD' | 'PTO_PCLD' | 'PTO_PS' | 'PTO_PE';

export function isOfTypeLogisticElementSubTypePoint(subtypeLogElem: string): subtypeLogElem is LogisticElementSubTypePoint {
  return ['PTO_PCPR', 'PTO_PCDB', 'PTO_PCCC', 'PTO_PCAS', 'PTO_PCI', 'PTO_PCY', 'PTO_PCTD', 'PTO_PCDD', 'PTO_PCLD', 'PTO_PS', 'PTO_PE'].includes(subtypeLogElem);
}